export const tobsaGroup = {
  siteName: "tobsa",
  senderName: "Tobsa Group",
  logo: "/static/warbox_logo.png",
  name: "Tobsa Group",
  api: {
    production: "https://api.warbox.io/api/v1",
    staging: "https://staging.api.warbox.io/api/v1",
    development: "http://localhost:5000/api/v1",
  },
  client: "tobsa-group",
};
